





















































import { defineComponent, computed, PropType, toRefs, nextTick } from '@vue/composition-api';
import { KeywordAuditStatus, SearchAdsKeywordItem } from '@ad/tt_ads_common_enums';
import { getDefaultKeywordItem } from '@tt4b/ttam-utils';
import { INPUT_DEBOUNCE_TIME } from '../const';
import { debounce } from 'lodash-es';

const name = 'ttam-search-keywords-input';
export default defineComponent({
  name,
  props: {
    index: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    focusedId: {
      type: String,
      default: '',
    },
    hoveredId: {
      type: String,
      default: '',
    },
    item: {
      type: Object as PropType<SearchAdsKeywordItem>,
      default: () => getDefaultKeywordItem(),
    },
    maxKeywordLength: {
      type: Number,
      default: 80,
    },
    isShowDisapprovedInfo: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { index, focusedId, hoveredId, item, isShowDisapprovedInfo, disabled } = toRefs(props);
    const isActive = computed(
      () =>
        (focusedId.value && item.value.id === focusedId.value) ||
        (hoveredId.value && item.value.id === hoveredId.value),
    );
    const isDisapproved = computed(
      () => isShowDisapprovedInfo.value && item.value.keywordAuditStatus === KeywordAuditStatus.REJECTED,
    );
    const isLoading = computed(() => item.value.loading);
    const disapprovedReason = computed(() => item.value.rejectReasons[0] || '');

    /** 事件监听用户操作 ----------------------------------- */
    function onFocus() {
      emit('on-focus', index.value);
    }

    function onBlur() {
      emit('on-blur', index.value);
    }

    function onMouseEnter() {
      emit('on-mouse-enter', index.value);
    }

    function onMouseLeave() {
      emit('on-mouse-leave');
    }

    function onKeyDown(e: KeyboardEvent) {
      emit('on-key-down', index.value, e);
    }

    const handleInputKeywords = debounce(function (val: string) {
      nextTick(() => {
        emit('on-keyword-change', index.value, val);
      });
    }, INPUT_DEBOUNCE_TIME);

    function onInput(val: string) {
      /** 先设置成val，避免原来input框的值和下面格式化之后的值相同，丢失响应式 */
      emit('on-input', index.value, val);

      handleInputKeywords(val);
    }

    function onDeleteClick() {
      if (disabled.value) {
        return false;
      }

      emit('on-delete', index.value);
    }

    return {
      name,
      isActive,
      isDisapproved,
      isLoading,
      disapprovedReason,
      onFocus,
      onBlur,
      onMouseEnter,
      onMouseLeave,
      onKeyDown,
      onInput,
      onDeleteClick,
    };
  },
});
